export default __webpack_public_path__ + "static/media/down.a9d94bad.png";